import React from "react";
import { useTranslation } from "react-i18next";
import DeleteDialogStyle from "styles/application/DeleteDialogStyle";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import { connect } from "react-redux";
import { showError } from "../../../../redux/common/actions";

// Init styled components
const ADD = DeleteDialogStyle();

const DeleteDialog = ({
	entityName,
	open,
	closeHandler,
	isDeleting,
	handleDelete,
}) => {
	const { t } = useTranslation();
	return (
		<div>
			<Dialog
				open={open}
				onClose={closeHandler}
				aria-labelledby="delete-title"
				aria-describedby="delete-description"
			>
				{isDeleting ? <LinearProgress /> : null}

				<ADD.ActionContainer>
					<DialogTitle id="delete-dialog-title">
						{
							<ADD.HeaderText>
								{t("title.deleteEntity", { name: entityName })}
							</ADD.HeaderText>
						}
					</DialogTitle>
					<ADD.ButtonContainer>
						<ADD.CancelButton onClick={closeHandler} variant="contained">
							{t("action.cancel")}
						</ADD.CancelButton>
						<ADD.DeleteButton onClick={handleDelete} variant="contained">
							{t("action.delete")}
						</ADD.DeleteButton>
					</ADD.ButtonContainer>
				</ADD.ActionContainer>

				<ADD.DialogContent>
					<ADD.InputContainer id="alert-dialog-description">
						{t("action.deleteConfirm", { name: entityName })}
					</ADD.InputContainer>
				</ADD.DialogContent>
			</Dialog>
		</div>
	);
};

const mapDispatchToProps = (dispatch) => ({
	getError: (msg) => dispatch(showError(msg)),
});

export default connect(null, mapDispatchToProps)(DeleteDialog);
